module.exports = __webpack_public_path__ + "img/Shield - Active.3845b474.svg";